var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.484375 0-256 114.496094-256 256 0 141.484375 114.496094 256 256 256 141.484375 0 256-114.496094 256-256 0-141.484375-114.496094-256-256-256zm0 472c-119.378906 0-216-96.609375-216-216 0-119.378906 96.609375-216 216-216 119.378906 0 216 96.609375 216 216 0 119.378906-96.609375 216-216 216zm180-269.332031v76c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20v-27.714844l-72.523438 72.523437c-7.8125 7.808594-20.476562 7.808594-28.285156 0l-92.523437-92.523437-92.523438 92.523437c-7.8125 7.808594-20.472656 7.8125-28.285156 0-7.808594-7.8125-7.808594-20.476562 0-28.285156l106.667969-106.667968c7.8125-7.808594 20.472656-7.808594 28.285156 0l92.523438 92.527343 58.378906-58.382812h-27.714844c-11.046875 0-20-8.953125-20-20s8.953125-20 20-20h76c11.210938 0 20 9.191406 20 20zm0 0",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#09D3AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.792a502fc798c9dfaecd1a22e94ed06a.svg";
export { ForwardRef as ReactComponent };